import * as React from 'react';

import { ActionIcon, Button, Grid, Group, Stack, Title, Tooltip, useMantineTheme } from '@mantine/core';
import { IconInfoCircleFilled } from '@tabler/icons-react';
import { useAuth } from 'context/auth-context';
import useStaffAvailabilityList from 'hooks/staffAvailability/useStaffAvailabilityList';

import WeeklyScheduleForm from './WeeklyScheduleForm';

const WeeklySchedule = ({
  isWeeklyScheduleEditable,
  toggleWeeklyScheduleEditable,
}: {
  isWeeklyScheduleEditable: boolean;
  toggleWeeklyScheduleEditable: () => void;
}): JSX.Element => {
  const theme = useMantineTheme();
  const { session } = useAuth();

  const { data } = useStaffAvailabilityList({
    staffId: session?.staff?.staffId,
  });

  return (
    <Grid.Col span={1}>
      <Stack sx={{ borderRight: `1px solid ${theme.colors.gray[3]}` }}>
        <Group
          align='center'
          position='apart'
          p='md'
          sx={{ borderBottom: `1px solid ${theme.colors.gray[3]}` }}
        >
          <Group>
            <Title order={2}>Weekly Schedule</Title>

            <Tooltip label='Time zones are determined using the gym’s local time.'>
              <ActionIcon color='kiloBlue'>
                <IconInfoCircleFilled size={theme.fontSizes.xl} />
              </ActionIcon>
            </Tooltip>
          </Group>
          {isWeeklyScheduleEditable ? (
            <Button onClick={toggleWeeklyScheduleEditable} variant='outline'>
              Go Back
            </Button>
          ) : (
            <Button onClick={toggleWeeklyScheduleEditable}>Edit</Button>
          )}
        </Group>

        {data && <WeeklyScheduleForm isEditable={isWeeklyScheduleEditable} data={data.data} />}
      </Stack>
    </Grid.Col>
  );
};

export default WeeklySchedule;
